export default function (editor, opt = {}) {
  const dc = editor.DomComponents;
  const defaultType = dc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;

  dc.addType(opt.types.carousel_container, {
    model: defaultModel.extend(
      {
        defaults: Object.assign({}, defaultModel.prototype.defaults, {
          'custom-name': opt.labels.carousel,
          classes: ['carousel'],
          traits: [
            {
              type: 'text',
              name: 'data-interval',
              label: 'Interval',
              placeholder: '5000',
            },
            {
              type: 'select',
              name: 'data-pause',
              label: 'Pause on Hover',
              options: [
                { value: 'hover', name: 'Yes' },
                { value: '', name: 'No' },
              ],
            },
          ].concat(defaultModel.prototype.defaults.traits),
        }),
      },
      {
        isComponent(el) {
          if (
            el.getAttribute &&
            el.getAttribute('data-gjs-type') === opt.types.carousel_container
          ) {
            return { type: opt.types.carousel_container };
          }
        },
      },
    ),
    view: defaultView,
  });

  dc.addType(opt.types.carousel_item, {
    model: defaultModel.extend(
      {
        defaults: Object.assign({}, defaultModel.prototype.defaults, {
          'custom-name': opt.labels.carousel_item,
          classes: ['carousel-item'],
          traits: [
            {
              type: 'class_select',
              options: [
                { value: '', name: 'No' },
                {
                  value: 'active',
                  name: 'Yes',
                },
              ],
              label: 'Active',
            },
          ].concat(defaultModel.prototype.defaults.traits),
        }),
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === opt.types.carousel_item) {
            return { type: opt.types.carousel_item };
          }
        },
      },
    ),
    view: defaultView,
  });

  dc.addType(opt.types.carousel_list_item, {
    model: defaultModel.extend(
      {
        defaults: Object.assign({}, defaultModel.prototype.defaults, {
          'custom-name': opt.labels.carousel_list_item,
          traits: [
            {
              type: 'class_select',
              options: [
                { value: '', name: 'No' },
                {
                  value: 'active',
                  name: 'Yes',
                },
              ],
              label: 'Active',
            },
            {
              type: 'text',
              name: 'data-target',
              label: 'Carousel #Id',
              placeholder: 'Carousel #Id',
            },
            {
              type: 'text',
              name: 'data-slide-to',
              label: 'Carousel Number',
              placeholder: 'Starts with 0',
            },
          ].concat(defaultModel.prototype.defaults.traits),
        }),
      },
      {
        isComponent(el) {
          if (
            el.getAttribute &&
            el.getAttribute('data-gjs-type') === opt.types.carousel_list_item
          ) {
            return { type: opt.types.carousel_list_item };
          }
        },
      },
    ),
    view: defaultView,
  });
}
